import { CircularProgress } from '@mui/material';
import { createPortal } from 'react-dom';
import DialogStyle from './ConfirmDialog.module.scss';
import { useFullscreenContainer } from 'core/utils/fullscreenContainer';

interface IConfirmDialog {
	type: 'shift' | 'event';
	isLoading: boolean;
	handleDeleteClick: () => void;
	setConfirmDeleteIsOpen: (args: boolean) => void;
}

export default function ConfirmDialog({
	type,
	isLoading,
	handleDeleteClick,
	setConfirmDeleteIsOpen,
}: IConfirmDialog): JSX.Element {
	const portalContainer = useFullscreenContainer(true);

	const dialog = (
		<div className={DialogStyle.dialogWrapper}>
			<div className={DialogStyle.dialogContent}>
				<div className={DialogStyle.dialogHeader}>
					<h3 className={DialogStyle.dialogTitle}>Delete {type === 'shift' ? 'Shift' : 'Event'}</h3>
				</div>
				<div className={DialogStyle.dialogBody}>
					<p>
						{type === 'shift'
							? 'Are you sure you want to delete this shift?'
							: 'Are you sure you want to delete this event?'}
					</p>
				</div>
				<div className={DialogStyle.dialogFooter}>
					{isLoading ? (
						<div className={DialogStyle.loadingContainer}>
							<CircularProgress size={20} />
							<span>Deleting...</span>
						</div>
					) : (
						<>
							<button 
								type="button"
								className={DialogStyle.cancelButton} 
								onClick={() => setConfirmDeleteIsOpen(false)}
								disabled={isLoading}
							>
								Cancel
							</button>
							<button 
								type="button"
								className={DialogStyle.deleteButton} 
								onClick={handleDeleteClick}
								disabled={isLoading}
							>
								Delete
							</button>
						</>
					)}
				</div>
			</div>
		</div>
	);

	if (portalContainer) {
		return createPortal(dialog, portalContainer);
	}

	return dialog;
}
